import React from 'react'
import clsx from 'clsx'
import { Products } from '@/components/organisms/MegaMenu/variants/products'
import { Features } from '@/components/organisms/MegaMenu/variants/features'
import { Integrations } from '@/components/organisms/MegaMenu/variants/integrations'
import { Resources } from '@/components/organisms/MegaMenu/variants/resources'
import { Articles } from '@/components/organisms/MegaMenu/variants/articles'
import { MegaMenuItem } from '@/components/molecules/MegaMenuItem/MegaMenuItem'
import * as styles from './MegaMenu.module.css'

type MegaMenuProps = {
  menus: {
    component: string
    dropdown_menu: MegaMenu[]
    text: string
    link: CustomLinkTypes[]
    link_url: Link
    _editable: string
    _uid: string
    variant?: 'products' | 'integrations' | 'features' | 'articles' | 'resources'
  }[]
  variant: 'products' | 'resources'
}

export function MegaMenu({ menus, variant }: MegaMenuProps) {
  // TODO remove after updating production storyblok to new DS
  if (!variant) {
    return (
      <ul
        className={clsx('netbook:absolute netbook:left-0 whitespace-normal', styles.dropdownMenu)}
        id="megamenu-dropdown"
      >
        <li className="bg-white flex flex-col netbook:flex-row netbook:rounded-lg netbook:shadow-xl">
          {menus &&
            menus?.map((menu) => (
              <div
                key={menu._uid}
                className="flex flex-col p-24 netbook:p-24 lg:p-40 w-full netbook:w-88 even:bg-offwhite netbook:even:rounded-lg"
              >
                <p className="text-xxs text-gray-dark font-bold capitalize mb-8">{menu.text}</p>
                <ul className="grid netbook:grid-cols-1 gap-24 netbook:gap-32">
                  {menu.dropdown_menu?.map((item) => <MegaMenuItem key={item._uid} item={item} variant={undefined} />)}
                </ul>
              </div>
            ))}
        </li>
      </ul>
    )
  }

  return (
    <ul
      className={clsx(
        'netbook:absolute max-netbook:border-b-1 max-netbook:border-grey-100 netbook:left-[5%] mt-24 netbook:mt-12 netbook:rounded-xl whitespace-normal overflow-hidden netbook:shadow-megamenu z-50',
        styles.dropdownMenu
      )}
      id="megamenu-dropdown"
    >
      <li
        className={clsx('bg-white', {
          'flex flex-col netbook:flex-row': variant === 'resources',
          'grid grid-cols-1 netbook:grid-cols-[691px,1fr] netbook:grid-rows-[1fr,auto]': variant === 'products'
        })}
      >
        {menus &&
          menus?.map((menu) => {
            switch (menu.variant) {
              case 'products': {
                return <Products menu={menu} key={menu._uid} />
              }
              case 'integrations': {
                return <Integrations menu={menu} key={menu._uid} />
              }
              case 'features': {
                return <Features menu={menu} key={menu._uid} />
              }
              case 'articles': {
                return <Articles menu={menu} key={menu._uid} />
              }
              case 'resources': {
                return <Resources menu={menu} key={menu._uid} />
              }
              default:
                return null
            }
          })}
      </li>
    </ul>
  )
}
